<template>
  <v-row justify="center" v-if="openModal">
    <v-dialog v-model="openModal" fullscreen persistent no-click-animation hide-overlay
      transition="dialog-bottom-transition">
      <v-form ref="propectingForm" v-model="isValidForm" lazy-validation>
        <v-card class="prospecting-card">
          <v-toolbar dark color="primary" class="prospecting-toolbar">
            <v-btn icon dark @click="closeProspectingModal" 
             :disabled="is_loading">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title class="text-h6">Prospecção</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="save_draft()"
                :disabled="is_loading || !prospecting.canSaveDraft && getCurrentUserRank === 'Franqueado'">
                Salvar
              </v-btn>
              <v-dialog v-model="dialog" max-width="320" persistent>
                <v-list class="py-5" color="primary" elevation="12" rounded>
                  <v-list-item class="d-flex justify-space-between">
                    <div>
                      <span class="white--text text-subtitle-1">Salvando prospecção...</span>
                    </div>
                    <div>
                      <v-progress-circular color="#1A237E" indeterminate size="32" width="2"></v-progress-circular>
                    </div>
                  </v-list-item>
                </v-list>
              </v-dialog>
            </v-toolbar-items>
          </v-toolbar>
          <div class="prospecting-content">
            <div v-if="startLoading" class="loader-wrapper">
              <v-progress-circular indeterminate color="primary" size="64"/>
            </div>
            <template v-else>
              <v-container fluid>
                <!-- Dados do Cliente -->
                <v-card class="mb-6" outlined>
                  <v-card-title class="text-h6 primary--text">
                    <v-icon left color="primary">mdi-account</v-icon>
                    Dados do Cliente
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="2">
                        <v-select
                          v-model="radioDocument"
                          :items="radioDocumentOptions"
                          :disabled="is_new_project || ((this.getCurrentUserRank === 'Franqueado') && (this.prospecting.approvalRequested || this.prospecting.approvalStatus) && !this.canSaveDraft)"
                          dense
                          outlined
                        ></v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field v-model="prospecting.document"
                          :label="`Digite ${radioDocument === 'Matrícula' ? 'a' : 'o'} ${radioDocument} do Cliente`" required
                          :rules="radioDocument == 'CPF' ? ruleCPF : radioDocument === 'CNPJ' ? rulesCNPJ : ruleRequired"
                          :disabled="disableFieldsWhenApprovalNeededOrApproved"
                          v-mask="radioDocument == 'CPF' ? '###.###.###-##' : radioDocument === 'CNPJ' ? '##.###.###/####-##' : ''"
                          outlined dense></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field v-model="prospecting.name" label="Razão Social" required
                          :rules="nameClient"
                          :disabled="disableFieldsWhenApprovalNeededOrApproved"
                          outlined dense></v-text-field>
                      </v-col>

                      <v-col cols="6">
                        <v-text-field v-model="prospecting.email" label="Email do Cliente" :counter="64"
                          :required="ruleString64" :rules="ruleEmail" 
                          :disabled="disableFieldsWhenApprovalNeededOrApproved"
                          outlined dense></v-text-field>
                      </v-col>

                      <v-col cols="6">
                        <v-text-field v-model="prospecting.phone" label="Telefone do Cliente" :required="rulePhone"
                          :rules="rulePhone" :disabled="disableFieldsWhenApprovalNeededOrApproved"
                          v-mask="phoneMask"
                          outlined dense></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <!-- Endereço -->
                <v-card class="mb-6" outlined>
                  <v-card-title class="text-h6 primary--text">
                    <v-icon left color="primary">mdi-map-marker</v-icon>
                    Endereço
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="3">
                        <v-text-field v-model="prospecting.zip_code" label="CEP" :required="ruleString64" @change="searchCEP"
                          :rules="ruleCEP" :disabled="disableFieldsWhenApprovalNeededOrApproved"
                          v-mask="'##.###-###'"
                          outlined dense></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field v-model="prospecting.address" label="Logradouro" :required="ruleString64"
                          :rules="ruleString64" :counter="128" 
                          :disabled="disableFieldsWhenApprovalNeededOrApproved"
                          outlined dense></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field v-model="prospecting.house_number" label="Número" :required="ruleString64" :counter="16"
                          :rules="ruleString64" 
                          :disabled="disableFieldsWhenApprovalNeededOrApproved"
                          outlined dense></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field v-model="prospecting.address_complement" label="Complemento" :required="ruleString64"
                          :counter="64"
                          :disabled="disableFieldsWhenApprovalNeededOrApproved"
                          outlined dense></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field v-model="prospecting.district" label="Bairro" :required="ruleString64" :counter="64"
                          :rules="ruleString64" 
                          :disabled="disableFieldsWhenApprovalNeededOrApproved"
                          outlined dense></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field v-model="prospecting.city" label="Cidade" :required="ruleString64" :counter="64"
                          :rules="ruleString64" 
                          :disabled="disableFieldsWhenApprovalNeededOrApproved"
                          outlined dense></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-select v-model="prospecting.uf" label="UF" :required="ruleString64" :items="state_acronyms"
                          :rules="ruleString64" 
                          :disabled="disableFieldsWhenApprovalNeededOrApproved"
                          outlined dense></v-select>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <!-- Dados do Responsável -->
                <v-card class="mb-6" outlined>
                  <v-card-title class="text-h6 primary--text">
                    <v-icon left color="primary">mdi-account-tie</v-icon>
                    Dados do Responsável
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="3">
                        <selectResponsibleType :id_responsible_type="prospecting.id_responsible_type" 
                        :rules="ruleRequired"
                        :disabled="disableFieldsWhenApprovalNeededOrApproved"
                        @id="(id) => prospecting.id_responsible_type = id" 
                        dense
                        outlined
                        />
                      </v-col>
                      <v-col cols="4">
                        <v-text-field v-model="prospecting.responsible_name" label="Nome do Responsável" :rules="ruleString64"
                          :disabled="disableFieldsWhenApprovalNeededOrApproved"
                          outlined dense></v-text-field>
                      </v-col>
                      <v-col cols="5">
                        <v-text-field v-model="prospecting.responsible_email" label="Email do Responsável"
                          :disabled="disableFieldsWhenApprovalNeededOrApproved"
                          :rules="ruleEmail"
                          outlined dense/>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field v-model="prospecting.responsible_document" label="CPF do Responsável"
                          :disabled="disableFieldsWhenApprovalNeededOrApproved"
                          v-mask="'###.###.###-##'"
                          outlined dense></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field v-model="prospecting.responsible_phone" label="Telefone do Responsável"
                          :rules="rulePhone" :disabled="disableFieldsWhenApprovalNeededOrApproved"
                          v-mask="responsiblePhoneMask"
                          outlined dense></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <!-- Dados da Conta -->
                <v-card class="mb-6" outlined>
                  <v-card-title class="text-h6 primary--text">
                    <v-icon left color="primary">mdi-bank</v-icon>
                    Dados da Conta
                    <v-spacer></v-spacer>
                    <v-checkbox
                      v-model="prospecting.no_account"
                      label="O cliente não possui conta"
                      :disabled="disableFieldsWhenApprovalNeededOrApproved"
                      class="mt-0"
                      @change="handleNoAccountChange"
                    ></v-checkbox>
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="7">
                        <v-row>
                          <v-col cols="6" v-if="!prospecting.no_account">
                            <v-text-field v-model="prospecting.registration" label="Matrícula" :counter="32"
                              v-mask="'################################'"
                              :rules="ruleRegistration"
                              :disabled="disableFieldsWhenApprovalNeededOrApproved"
                              outlined dense />
                          </v-col>
                          <v-col cols="6" v-if="!prospecting.no_account">
                            <v-text-field type="Number" prefix="R$" @change="removeLeftZeroAndFormatCurrency()" v-model="prospecting.minimum_rate" label="Taxa Mínima"
                              :rules="ruleMinimumRate"
                              :disabled="disableFieldsWhenApprovalNeededOrApproved"
                              outlined dense />
                          </v-col>
                          <v-col cols="6" v-if="!prospecting.no_account">
                            <v-checkbox :disabled="disableFieldsWhenApprovalNeededOrApproved"
                              v-model="prospecting.water_consumption" label="A unidade paga água?"></v-checkbox>
                          </v-col>
                          <v-col cols="6" v-if="!prospecting.no_account">
                            <v-checkbox :disabled="disableFieldsWhenApprovalNeededOrApproved"
                              v-model="prospecting.sewer_consumption" label="A unidade paga esgoto?"></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" sm="5" v-if="!prospecting.no_account">
                        <InputFiles 
                          :disabled="disableFieldsWhenApprovalNeededOrApproved" 
                          title="Adicionar Arquivo da Conta (PDF ou Excel)"
                          :fileTypes="['pdf', 'xlsx', 'xls']"
                          :showFile="prospecting.file_photo_account_dealership"
                          :required="!prospecting.no_account"
                          :rules="[v => !v && !prospecting.no_account ? 'O arquivo da conta é obrigatório' : true]"
                          @change:file="(file) => prospecting.file_photo_account_dealership = file" 
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <!-- Confirmation Dialog -->
                <v-dialog v-model="showNoAccountDialog" max-width="400" persistent>
                  <v-card>
                    <v-card-title class="text-h6">
                      Confirmação
                    </v-card-title>
                    <v-card-text>
                      Ao marcar esta opção, você assume total responsabilidade pela veracidade desta informação. Caso seja constatado que o cliente possui contas na concessionária de água, a proposta será reiniciada para as devidas correções. Certifique-se antes de prosseguir.
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="confirmNoAccount">
                        Confirmar
                      </v-btn>
                      <v-btn color="error" text @click="cancelNoAccount">
                        Cancelar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <!-- Histórico -->
                <v-card class="mb-6" outlined v-if="!prospecting.no_account">
                  <v-card-title class="text-h6 primary--text">
                    <v-icon left color="primary">mdi-history</v-icon>
                    Histórico de Referência
                    <v-spacer></v-spacer>
                    <div class="d-flex align-center">
                      <span class="text-caption grey--text mr-2">Média Financeira Local</span>
                      <span class="text-h6 font-weight-bold">
                        {{ prospecting.financial_average_per_local }}
                      </span>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <historicReference :disabled="disableFieldsWhenApprovalNeededOrApproved" :list="prospecting.historics"
                      :add="addHistoric" :remove="removeHistoric" :showLeakField="true" />
                  </v-card-text>
                </v-card>

                <!-- Dados do Local -->
                <v-card class="mb-6" outlined>
                  <v-card-title class="text-h6 primary--text">
                    <v-icon left color="primary">mdi-home</v-icon>
                    Dados do Local
                    <v-spacer></v-spacer>
                    <div class="d-flex align-center">
                      <span class="text-caption grey--text mr-2">Potencial de Economia</span>
                      <div class="d-flex align-center">
                        <span 
                          :class="[
                            prospecting.no_account ? 'grey--text text--darken-1 text-body-2' : (financialAverageColor ? `${financialAverageColor}--text` : ''), 
                            prospecting.no_account ? '' : 'text-h6 font-weight-bold'
                          ]"
                        >
                          {{ potentialSavings }}
                        </span>
                        <v-tooltip bottom v-if="financialAverageColor || prospecting.no_account">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon 
                              :color="prospecting.no_account ? 'grey' : financialAverageColor"
                              :size="prospecting.no_account ? 18 : undefined"
                              class="ml-2"
                              v-bind="attrs"
                              v-on="on"
                            >
                              {{ prospecting.no_account ? 'mdi-information-outline' : 
                                 (financialAverageColor === 'error' ? 'mdi-alert-circle' : 
                                 financialAverageColor === 'info' ? 'mdi-alert' : 'mdi-check-circle') }}
                            </v-icon>
                          </template>
                          <span v-if="prospecting.no_account">Cliente não possui conta</span>
                          <span v-else-if="financialAverageColor === 'error'">Potencial abaixo da taxa mínima</span>
                          <span v-else-if="financialAverageColor === 'info'">Potencial abaixo de (30%)</span>
                          <span v-else>Potencial acima de (30%)</span>
                        </v-tooltip>
                      </div>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="7">
                        <v-row>
                          <v-col cols="6">
                            <v-select
                              v-model="prospecting.location_type"
                              :items="locationTypeOptions"
                              label="Tipo de Local"
                              :disabled="disableFieldsWhenApprovalNeededOrApproved"
                              outlined
                              dense
                              @change="onLocationTypeChange"
                            ></v-select>
                          </v-col>
                          <v-col cols="6">
                            <v-select
                              v-model="prospecting.individual_collective"
                              :items="individualCollectiveOptions"
                              label="Individual ou Coletivo"
                              :disabled="disableFieldsWhenApprovalNeededOrApproved"
                              outlined
                              dense
                            ></v-select>
                          </v-col>
                          <v-col cols="6">
                            <v-checkbox
                              v-model="prospecting.is_network"
                              label="Rede de estabelecimentos"
                              :disabled="disableFieldsWhenApprovalNeededOrApproved"
                              @change="onNetworkChange"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="6" v-if="prospecting.is_network">
                            <v-text-field
                              v-model="prospecting.network_units_count"
                              label="Quantas unidades tem na rede?"
                              type="Number"
                              :rules="ruleIntPositive"
                              :disabled="disableFieldsWhenApprovalNeededOrApproved"
                              outlined
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" v-if="prospecting.location_type === 'comercial'">
                            <v-select
                              v-model="prospecting.commercial_subtype"
                              :items="commercialSubtypeOptions"
                              label="Tipo Comercial"
                              :disabled="disableFieldsWhenApprovalNeededOrApproved"
                              outlined
                              dense
                            ></v-select>
                          </v-col>
                          <v-col cols="6" v-if="prospecting.location_type === 'residencial'">
                            <v-select
                              v-model="prospecting.residential_subtype"
                              :items="residentialSubtypeOptions"
                              label="Tipo Residencial"
                              :disabled="disableFieldsWhenApprovalNeededOrApproved"
                              outlined
                              dense
                            ></v-select>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field v-model="prospecting.number_towers" @change="updateNumberUnits()"
                              label="Quantidade de Torres" type="Number" :rules="ruleIntPositive" 
                              :disabled="disableFieldsWhenApprovalNeededOrApproved"
                              outlined dense />
                          </v-col>
                          <v-col cols="6">
                            <v-text-field v-model="prospecting.number_floors" @change="updateNumberUnits()"
                              label="Número de Pavimentos" type="Number" :rules="ruleIntPositive" 
                              :disabled="disableFieldsWhenApprovalNeededOrApproved"
                              outlined dense></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field v-model="prospecting.unit_by_floor" @change="updateNumberUnits()"
                              label="Unidades por Andar" type="Number" :rules="ruleIntPositive" 
                              :disabled="disableFieldsWhenApprovalNeededOrApproved"
                              outlined dense></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field v-model="prospecting.wcs_by_unit" label="Banheiros por Unidade" type="Number"
                              :rules="ruleIntPositive" 
                              :disabled="disableFieldsWhenApprovalNeededOrApproved"
                              outlined dense></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field v-model="prospecting.number_units" label="Quantidade de Unidades *" type="Number"
                              :rules="ruleIntPositive" :loading="is_loading"
                              :disabled="disableFieldsWhenApprovalNeededOrApproved"
                              outlined dense />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" sm="5">
                        <InputFiles title="Adicionar Foto da Fachada" 
                          :disabled="disableFieldsWhenApprovalNeededOrApproved" :fileTypes="['image']"
                          :showFile="prospecting.file_photo_unit_facade"
                          @change:file="(file) => prospecting.file_photo_unit_facade = file" />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                     <!-- Dados Adicionais -->
                     <v-card class="mb-6" outlined>
                  <v-card-title class="text-h6 primary--text">
                    <v-icon left color="primary">mdi-information</v-icon>
                    Dados Adicionais
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <v-select item-value="value" label="Proposta Desejada" :disabled="disableFieldsWhenApprovalNeededOrApproved" :items="availableProposalTypes"
                          v-model="prospecting.desiredProposal" :rules="requiredAtLeastOne" multiple outlined dense />
                        <div v-if="isPerformanceModelBlocked() && getCurrentUserRank === 'Franqueado' && !prospecting.performance_exception_requested" class="mt-3">
                          <v-alert
                          dense
                          text
                          type="info"
                          class="mt-2"
                        >
                          As propostas que você selecionar serão as analisadas pela equipe, porém é possível que um ou mais modelos não seja aprovado com base nos dados de consumo do cliente
                        </v-alert>
                          <v-alert
                            dense
                            text
                            type="warning"
                            class="mb-2"
                          >
                            Modelo Performance está bloqueado pelos parâmetros atuais. Você pode solicitar uma revisão para liberar este modelo.
                          </v-alert>
                          <v-textarea
                            v-model="prospecting.performance_exception_observation"
                            :disabled="disableFieldsWhenApprovalNeededOrApproved"
                            label="Observação para solicitação de revisão (opcional)"
                            outlined
                            dense
                            auto-grow
                          />
                          <v-btn
                            color="primary"
                            class="mt-2"
                            :disabled="disableFieldsWhenApprovalNeededOrApproved"
                            @click="requestPerformanceException"
                          >
                            Pedir Revisão para Liberar Performance
                          </v-btn>
                        </div>
                        <v-alert
                          v-if="prospecting.performance_exception_requested"
                          dense
                          text
                          type="info"
                          class="mt-2"
                        >
                          Revisão solicitada para liberação do modelo Performance. O modelo será liberado após aprovação do analista.
                        </v-alert>

                        <!-- Seção para Administradores - Solicitação de Revisão do Performance -->
                        <div v-if="getCurrentUserRank !== 'Franqueado' && prospecting.performance_exception_requested" class="mt-3">
                          <v-alert
                            dense
                            text
                            type="warning"
                            class="mb-3"
                          >
                            <strong>Solicitação de Revisão do Modelo Performance</strong>
                            <br>
                            O franqueado solicitou a liberação do modelo Performance que está bloqueado pelos parâmetros atuais.
                          </v-alert>
                          
                          <v-card outlined class="mb-3">
                            <v-card-title class="text-subtitle-1 primary--text">
                              <v-icon left color="primary">mdi-information</v-icon>
                              Motivo da Solicitação
                            </v-card-title>
                            <v-card-text>
                              <div v-if="prospecting.performance_exception_observation" class="mb-3">
                                <strong>Observação do Franqueado:</strong>
                                <p class="mt-2 mb-0">{{ prospecting.performance_exception_observation }}</p>
                              </div>
                              <div v-else class="mb-3">
                                <em class="grey--text">Nenhuma observação foi fornecida pelo franqueado.</em>
                              </div>
                              
                              <div>
                                <strong>Motivos do Bloqueio:</strong>
                                <ul class="mt-2 mb-0">
                                  <li v-for="reason in performanceBlockingReasons" :key="reason">
                                    {{ reason }}
                                  </li>
                                </ul>
                              </div>
                            </v-card-text>
                          </v-card>

                          <v-card outlined>
                            <v-card-title class="text-subtitle-1 primary--text">
                              <v-icon left color="primary">mdi-check-decagram</v-icon>
                              Decisão da Revisão
                            </v-card-title>
                            <v-card-text>
                              <v-row>
                                <v-col cols="12" sm="4">
                                  <v-radio-group
                                    v-model="prospecting.performance_exception_status"
                                    :disabled="is_loading"
                                  >
                                    <v-radio
                                      label="Aprovar"
                                      value="approved"
                                      color="success"
                                    ></v-radio>
                                    <v-radio
                                      label="Reprovar"
                                      value="reproved"
                                      color="error"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-col>
                                <v-col cols="12" sm="8">
                                  <v-textarea
                                    v-model="prospecting.performance_exception_admin_observation"
                                    label="Observação da Decisão (opcional)"
                                    :disabled="is_loading"
                                    outlined
                                    dense
                                    auto-grow
                                    rows="3"
                                  />
                                </v-col>
                              </v-row>
                              <v-btn
                                color="primary"
                                :disabled="is_loading || !prospecting.performance_exception_status"
                                :loading="is_loading"
                                @click="savePerformanceExceptionDecision"
                                class="mt-3"
                              >
                                Salvar Decisão
                              </v-btn>
                            </v-card-text>
                          </v-card>
                        </div>

                        <!-- Status da Decisão da Revisão do Performance -->
                        <div v-if="prospecting.performance_exception_status === 'approved'" class="mt-3">
                          <v-alert
                            dense
                            text
                            type="success"
                            class="mb-2"
                          >
                            <strong>✓ Solicitação Aprovada</strong>
                            <br>
                            O modelo Performance foi liberado para este projeto.
                            <div v-if="prospecting.performance_exception_admin_observation" class="mt-2">
                              <strong>Observação do Administrador:</strong> {{ prospecting.performance_exception_admin_observation }}
                            </div>
                          </v-alert>
                        </div>

                        <div v-if="prospecting.performance_exception_status === 'reproved'" class="mt-3">
                          <v-alert
                            dense
                            text
                            type="error"
                            class="mb-2"
                          >
                            <strong>✗ Solicitação Reprovada</strong>
                            <br>
                            O modelo Performance permanece bloqueado para este projeto.
                            <div v-if="prospecting.performance_exception_admin_observation" class="mt-2">
                              <strong>Observação do Administrador:</strong> {{ prospecting.performance_exception_admin_observation }}
                            </div>
                          </v-alert>
                        </div>
                        
                        <v-alert
                          v-if="isPerformanceModelBlocked()"
                          dense
                          text
                          type="warning"
                          class="mt-2"
                        >
                          <strong>Modelo Performance não disponível:</strong>
                          <ul class="mt-1 mb-0">
                            <li v-for="reason in performanceBlockingReasons" :key="reason">
                              {{ reason }}
                            </li>
                          </ul>
                        </v-alert>
                      </v-col>
                      <v-col cols="6">
                        <selectProjectPartner :id_project_partner="prospecting.id_project_partner"
                          :disabled="disableFieldsWhenApprovalNeededOrApproved"
                          @id="(id) => prospecting.id_project_partner = id" 
                          outlined dense
                          />
                      </v-col>
                      <v-col cols="6">
                        <selectProjectHunter :id_project_hunter="prospecting.id_project_hunter"
                          :disabled="disableFieldsWhenApprovalNeededOrApproved"
                          @id="(id) => prospecting.id_project_hunter = id"
                          outlined dense
                          />
                      </v-col>
                      <v-col cols="6">
                        <selectProjectSeller :id_project_seller="prospecting.id_project_seller"
                          :disabled="disableFieldsWhenApprovalNeededOrApproved"
                          @id="(id) => prospecting.id_project_seller = id" 
                           outlined dense
                          />
                      </v-col>
                      <v-col cols="6">
                        <selectProjectCloser :id_project_closer="prospecting.id_project_closer"
                          :disabled="disableFieldsWhenApprovalNeededOrApproved"
                          @id="(id) => prospecting.id_project_closer = id" 
                           outlined dense
                          />
                      </v-col>
                     
                      <v-col cols="12">
                        <v-textarea :disabled="disableFieldsWhenApprovalNeededOrApproved" v-model="prospecting.prospectingObservation" label="Observações" outlined dense />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                
              </v-container>

            </template>
                
                <!-- Alerta para prospecções antigas travadas -->
                <v-alert
                  v-if="isOldProspectingNeedingApproval"
                  dense
                  text
                  type="warning"
                  class="mx-4 mb-4"
                >
                  <strong>Atenção:</strong> Esta é uma prospecção antiga que estava travada no fluxo de aprovação. 
                  Use o botão abaixo para aprová-la manualmente e liberar o projeto para a próxima etapa.
                </v-alert>

                <!-- Botão para aprovar prospecções antigas travadas -->
                <NextStepProject v-if="isOldProspectingNeedingApproval"
                   :disabled="is_loading || is_completed" 
                   :click="approveOldProspecting"
                   message="Aprovar Prospecção Antiga" />

                <!-- Botão para decisão de revisão (admin) -->
                <NextStepProject v-else-if="getCurrentUserRank !== 'Franqueado' && prospecting.approvalRequested"
                   :disabled="is_loading ||is_completed || !prospecting.approvalRequested" :click="saveDecision"
                  message="Salvar Revisão" />

                <!-- Botão padrão (próximo passo) -->
                <NextStepProject v-else  :disabled="is_loading || is_completed ||
                  (prospecting.approvalRequested && prospecting.approvalStatus !== 'revision')" :click="nextStep" :message="updateButtonMessage()" />

              <!-- <AverageNextStep
                ref="averageModal"
                :model-value="showAverageNextStep"
                :next-step="nextStepVariable"  
              /> -->
          </div>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import Prospecting from "./Prospecting.js";
export default Prospecting;
</script>

<style scoped>
.prospecting-card {
  height: 100%;
}

.prospecting-toolbar {
  height: 64px;
  position: fixed;
  width: 100%;
  z-index: 1000;
  border-radius: 0 0 10px 10px;
}

.prospecting-content {
  padding-top: 64px;
  padding-bottom: 86px;
}

.loader-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 200px);
  width: 100%;
}

.v-card-title {
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.v-card-text {
  padding: 16px;
}

.v-text-field--outlined >>> fieldset {
  border-color: rgba(0, 0, 0, 0.12);
}

.v-text-field--outlined:focus-within >>> fieldset {
  border-color: var(--v-primary-base);
}

.v-input--radio-group {
  margin-top: 0;
}

.v-radio {
  margin-bottom: 8px;
}

.v-radio:last-child {
  margin-bottom: 0;
}

.v-textarea {
  margin-top: 8px;
}

.v-checkbox {
  margin-top: 8px;
}

/* Estilos específicos para o campo de média financeira */
.v-text-field--outlined >>> .v-input__slot {
  background-color: transparent !important;
}

.v-text-field--outlined >>> .v-text-field__slot input {
  color: inherit !important;
  opacity: 1 !important;
}

.v-text-field--outlined >>> .v-label {
  color: inherit !important;
  opacity: 1 !important;
}

.v-text-field--outlined >>> .v-input__control {
  color: inherit !important;
}

.v-text-field--outlined >>> .v-input__slot::before {
  border-color: inherit !important;
}

.v-text-field--outlined >>> .v-input__slot::after {
  border-color: inherit !important;
}
</style>